/**
 * UcCrossSellRulesApiService — admin data-access layer for the Ultimate
 * Cart cross-sell rule builder (Marketing → Cross-Sell Rules).
 *
 * Subclasses Shopware's own ApiService so getBasicHeaders() auto-attaches
 * Authorization + sw-language-id on every request, instead of hand-rolling
 * headers on each call from the component.
 *
 * Maps 1-to-1 to CrossSellRulesAdminController:
 *   getRules / createRule / updateRule / deleteRule / reorderRules
 */
const ApiService = Shopware.Classes.ApiService;

class UcCrossSellRulesApiService extends ApiService {
    constructor(httpClient, loginService, apiEndpoint = 'sellops-uc') {
        super(httpClient, loginService, apiEndpoint);
        this.name = 'ucCrossSellRulesApiService';
    }

    /**
     * @param {string|null} [salesChannelId] Optional filter — when set, the
     *   server returns rules scoped to that sales channel plus any global
     *   rules (salesChannelId=null).
     */
    getRules(salesChannelId = null) {
        const config = { headers: this.getBasicHeaders() };
        if (salesChannelId) {
            config.params = { salesChannelId };
        }

        return this.httpClient
            .get('/sellops-uc/cross-sell-rules', config)
            .then(ApiService.handleResponse.bind(ApiService));
    }

    createRule(rule) {
        return this.httpClient
            .post('/sellops-uc/cross-sell-rules', rule, {
                headers: this.getBasicHeaders(),
            })
            .then(ApiService.handleResponse.bind(ApiService));
    }

    updateRule(id, rule) {
        return this.httpClient
            .put(`/sellops-uc/cross-sell-rules/${id}`, rule, {
                headers: this.getBasicHeaders(),
            })
            .then(ApiService.handleResponse.bind(ApiService));
    }

    deleteRule(id) {
        return this.httpClient
            .delete(`/sellops-uc/cross-sell-rules/${id}`, {
                headers: this.getBasicHeaders(),
            })
            .then(ApiService.handleResponse.bind(ApiService));
    }

    /**
     * @param {string[]} ids UUIDs in the desired display order — the server
     *   assigns `priority = index_in_array` to each.
     */
    reorderRules(ids) {
        return this.httpClient
            .post('/sellops-uc/cross-sell-rules/reorder', { ids }, {
                headers: this.getBasicHeaders(),
            })
            .then(ApiService.handleResponse.bind(ApiService));
    }
}

export default UcCrossSellRulesApiService;
